'use strict';

exports.__esModule = true;
exports.default = {
  metadataField: 'reactFormalType',
  events: ['onChange', 'onBlur'],
  errorClass: 'invalid-field'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-formal/lib/config.js
// module id = 539
// module chunks = 0